
# 2020-01-23: A Letter to Larry

## Christian's Context

- My mom is a middle school special education teacher
- I joined Amplify in early 2018 as a consultant for the New York City 5 boroughs offline initiative
- By end of spring the technology we built to produce PDFs had saved thousands of hours and as a company we more or less officially had "textbooks"
- Then came the research
  - What percentage of the market does Amplify own?
  - What's the company history? Emerson, oh.
  - What's the big 3?
  - What does education innovation/evolution look like?
  - Procurement?
  - Supply chain?
  - Core/basal vs supplementals?

## Questions

### Amplify

What is your hope the next 5-10 years of Amplify?

What are all parties currently involved in the procurement process and what's our responsibility to each as a curriculum company?

> Business/Exec -> Product -> Engineering -> Product -> Politics/Procurement -> Administrators -> Teachers -> Students -> Parents

The writing on the wall in my eyes is that our ability to make a profit will soon push us from the red to the black. How has the last 20 years of experimentation either validated or negated your various philosophies on education?

### Emerson

Our relationship with Emerson intrigues me especially in recent investments where they don't necessarily seem to be seeking a return on investment. In your eyes is Emerson unique compared to other angel investors?
  
Our math curriculum seems to be a partitioned investment from the rest of Emerson's current involvement in Amplify. This seems insanely charitable compared to other angels, no?

### HQIM+

Are you familiar with the term "trickle down teaching"? Maybe as it relates to policy philosophy and philanthropy?

As procurement policy stretches towards quality over status quo in regards to instructional materials, where does Amplify stand?

### Math

Math is a unique "core" subject in that curriculum is usually authored through high school compared to elementary/middle/high school chunks, no? How good does it feel to be able to call ourselves a K-12 company?

### Schools, Tools and Curriculum

What's Larry's strategy and/or viewpoint towards learning management systems (LMS) and the seemingly growing concern for reducing technological clutter in the classroom?

Is Amplify a tool builder or a curriculum producer? Science and Math as compared to ELA and Reading.

> Math --> (Desmos + Curriculum Producer X)
> Science --> LHS
> ELA --> in-house

### Procurement

While adding new support to our authoring platform, I noticed just how much politics and policy sit behind certain editions of curriculum content. Especially in regards to politics in certain states, what's our responsibility as an education provider in these matters?

---

## History

- public education 18th century
  - have public education (whoever could afford)
- public edu 19th century
  - taxes to fund
- fix laws 1950s legal problem
- beat Russians at curriculum 1959
  - American defense and education act
  - if you wanted billion of funding to make curriculum there was affidavit to sign that you didn't believe in overthrow of US government
- fix poverty 1960s civil rights as well
- fund public education 1965
- fix management 1970
- fix expectations 1990s subjects and grades (Nation at Risk)
- fix governance 1990s (charters and choice)
  - nobody is defunding education
  - where does the money go then?
  - more in absolute items but definitely increase in line items
- have standards 1990s (goals 2000)
- have accountability 2002 no child left behind
- fix teachers 2010
  - incentives
  - trickle down teaching? Bill Gates
- fix standards and accountability 2010
- fix instructional materials 2015
  - testing? no future for it
  - how are we teaching?

## A New Era in Education

- HQIM 2019+ high quality instructional materials
  - Ed Reports (meet standards)
  - start with the curriculum to train with the material and then grow from there (DERIVATION) start small and get big
  - write assessments about what the kids know
  - Amplify as an organization is growing here but the foundation is all these things
  - we're enabled now in 2015 to not have a silver bullet but to think about the what and the how and the why

“Trickle-down teaching” is dead; long live HQIM (high-quality instructional materials).

## Education Entrepreneurship

I recently took a stab at [this paper](https://d3e7x39d4i7wbe.cloudfront.net/uploads/pdf/file/15/K12_Entrepreneurship__-1523562447.pdf) written by Larry Berger and David Stevenson in October 2007.

What big pieces emerged for me as we now enter 2020 onwards?

*How does Amplify avoid a "this too shall pass"?*

> "we couldn’t make a thick, difficult product that required in-depth, one-on-one training"

Very interesting how the term "thick" has now bled out into our nomenclature dealing with IMS Global Learning Consortium Common Cartridges for Chicago Public School Systems. Thin vs thick instructional materials?
